var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.9668H16V4.9668C16 3.3128 14.654 1.9668 13 1.9668H11C9.346 1.9668 8 3.3128 8 4.9668V5.9668H3V7.9668H4.992L5.79 18.3398C5.949 20.4098 7.701 22.0328 9.778 22.0328H14.221C16.298 22.0328 18.05 20.4098 18.209 18.3398L19.007 7.9668H21V5.9668ZM10 4.9668C10 4.4158 10.449 3.9668 11 3.9668H13C13.551 3.9668 14 4.4158 14 4.9668V5.9668H10V4.9668ZM16.216 18.1858C16.136 19.2218 15.26 20.0328 14.222 20.0328H9.778C8.739 20.0328 7.863 19.2218 7.784 18.1858L6.998 7.9668H17.002L16.216 18.1858Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinM);
export default __webpack_public_path__ + "static/media/bin-M.02a4eb5b34144fe4dae748e67e1f9c02.svg";
export { ForwardRef as ReactComponent };